const developmentLoggingEnabled = process.env.NODE_ENV !== "production";

export const debugLog = (...args) => {
  if (developmentLoggingEnabled) {
    const browserConsole =
      typeof window !== "undefined" ? window.console : undefined;

    browserConsole?.debug(...args);
  }
};
